import { ImagesHeaderChevronRightSvg } from '@/assets/images_header.assets';
import DefaultButton from '@/components/common/default/DefaultButton';
import DefaultLink from '@/components/common/default/DefaultLink';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { useAnalytics } from '@/hooks/useAnalytics';
import useEvents from '@/hooks/useEvents';
import { useRouter } from 'next/router';
import { MobileMenuDialogMenuMainProps } from '@/types/props/components/layout';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import { Transition } from '@headlessui/react';
import Image from 'next/image';

export default function MobileMenuDialogMenuMain({
  setCurrentSubMenuActive,
  currentSubMenuActive,
  onClose,
  setContactFormOpen,
}: MobileMenuDialogMenuMainProps) {
  const { translate } = useTypedTranslation<HeaderEnum>('header');
  const { getPageType } = useAnalytics();
  const { firePortfolioButtonClickEvent } = useEvents('', []);
  const router = useRouter();

  return (
    <Transition
      show={currentSubMenuActive === 'none'}
      enter="tw-transition-opacity tw-duration-150"
      enterFrom="tw-opacity-0"
      enterTo="tw-opacity-100"
      leave="tw-transition-opacity tw-duration-150"
      leaveFrom="tw-opacity-100"
      leaveTo="tw-opacity-0"
      as={'div'}
    >
      <ul className="tw-flex tw-list-none tw-flex-col tw-gap-4 tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-platinum-gray tw-p-0 tw-pb-4 tw-pt-5">
        <li className="pb-2">
          <strong className="tw-font-plusJakartaSans tw-text-base tw-font-semibold tw-leading-[20.16px] tw-text-textBlack">
            {translate(HeaderEnum['mobile_menu.buy_spirits.buy_spirits'])}
          </strong>
        </li>
        <li>
          <DefaultButton
            className="tw-flex tw-w-full tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack max-nine:!tw-text-sm nine:tw-min-w-[unset]"
            onClick={() => setCurrentSubMenuActive('type')}
          >
            {translate(HeaderEnum['mobile_menu.buy_spirits.type'])}

            <Image src={ImagesHeaderChevronRightSvg} width={6} height={12} alt="chevron right" />
          </DefaultButton>
        </li>
        <li>
          <DefaultButton
            className="tw-flex tw-w-full tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack max-nine:!tw-text-sm nine:tw-min-w-[unset]"
            onClick={() => setCurrentSubMenuActive('brand')}
          >
            {translate(HeaderEnum['mobile_menu.buy_spirits.brand'])}

            <Image src={ImagesHeaderChevronRightSvg} width={6} height={12} alt="chevron right" />
          </DefaultButton>
        </li>
        <li>
          <DefaultButton
            className="tw-flex tw-w-full tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack max-nine:!tw-text-sm nine:tw-min-w-[unset]"
            onClick={() => setCurrentSubMenuActive('countries')}
          >
            {translate(HeaderEnum['mobile_menu.buy_spirits.countries'])}

            <Image src={ImagesHeaderChevronRightSvg} width={6} height={12} alt="chevron right" />
          </DefaultButton>
        </li>
        <li>
          <DefaultButton
            className="tw-flex tw-w-full tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack max-nine:!tw-text-sm nine:tw-min-w-[unset]"
            onClick={() => setCurrentSubMenuActive('topics')}
          >
            {translate(HeaderEnum['mobile_menu.buy_spirits.topics'])}

            <Image src={ImagesHeaderChevronRightSvg} width={6} height={12} alt="chevron right" />
          </DefaultButton>
        </li>
      </ul>
      {/* SELL SPIRITS */}
      <ul className="tw-flex tw-list-none tw-flex-col tw-gap-4 tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-platinum-gray tw-p-0 tw-pb-4 tw-pt-5">
        <li className="pb-2">
          <strong className="tw-font-plusJakartaSans tw-text-base tw-font-semibold tw-leading-[20.16px] tw-text-textBlack">
            {translate(HeaderEnum['mobile_menu.sell_spirits.sell_spirits'])}
          </strong>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/auth/onboarding/seller/personal-information"
          >
            {translate(HeaderEnum['mobile_menu.sell_spirits.become_a_seller'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/seller-guide"
          >
            {translate(HeaderEnum['mobile_menu.sell_spirits.seller_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/authenticating"
          >
            {translate(HeaderEnum['mobile_menu.sell_spirits.authentication'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/shipping-guide"
          >
            {translate(HeaderEnum['mobile_menu.sell_spirits.shipping_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/condition-guide"
          >
            {translate(HeaderEnum['mobile_menu.sell_spirits.bottle_condition'])}
          </DefaultLink>
        </li>
      </ul>
      {/* ABOUT SPIRITORY */}
      <ul className="tw-flex tw-list-none tw-flex-col tw-gap-4 tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-platinum-gray tw-p-0 tw-pb-4 tw-pt-5">
        <li className="pb-2">
          <strong className="tw-font-plusJakartaSans tw-text-base tw-font-bold tw-leading-[20.16px] tw-text-[#272D37]">
            {translate(HeaderEnum['mobile_menu.about_spiritory.about_spiritory'])}
          </strong>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/how-it-works"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.how_it_works'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/buyer-guide"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.buyer_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/seller-guide"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.seller_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/authenticating"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.authentication'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/portfolio-guide"
            onClick={e => {
              e.preventDefault();
              router.push('/portfolio-guide');
            }}
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.portfolio_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/condition-guide"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.bottle_condition'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/collections"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.collection'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/shipping-guide"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.shipping_guide'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/help"
          >
            {translate(HeaderEnum['mobile_menu.about_spiritory.help'])}
          </DefaultLink>
        </li>
      </ul>
      {/* OTHERS */}
      <ul className="tw-flex tw-list-none tw-flex-col tw-gap-4 tw-border tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-platinum-gray tw-p-0 tw-pb-4 tw-pt-5">
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/blog"
          >
            {translate(HeaderEnum['mobile_menu.blog'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultLink
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            href="/help"
          >
            {translate(HeaderEnum['mobile_menu.faq'])}
          </DefaultLink>
        </li>
        <li>
          <DefaultButton
            className="tw-flex tw-items-center tw-justify-between tw-font-plusJakartaSans tw-text-sm tw-font-medium tw-leading-[20.16px] tw-text-textBlack"
            onClick={() => {
              setContactFormOpen(true);
              onClose();
            }}
          >
            {translate(HeaderEnum['mobile_menu.contact'])}
          </DefaultButton>
        </li>
      </ul>
    </Transition>
  );
}
